import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all projectStatuses
export const getProjectStatus = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/project-status`);
    return response.data;
  } catch (error) {
    console.error("Error fetching project-status:", error.response?.data || error);
    throw error;
  }
};

// GET a single projectStatus
export const getProjectStatusById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/project-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching project-status:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new projectStatus
export const createProjectStatus = async (projectStatusData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/project-status`, projectStatusData);
    return response.data;
  } catch (error) {
    console.error("Error creating project-status:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing projectStatus
export const updateProjectStatus = async (id, projectStatusData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/project-status/${id}`, projectStatusData);
    return response.data;
  } catch (error) {
    console.error("Error updating project-status:", error.response?.data || error);
    throw error;
  }
};

// DELETE a projectStatus
export const deleteProjectStatus = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/project-status/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting project-status:", error.response?.data || error);
    throw error;
  }
};
